import FamilyPromoCard from './FamilyPromoCard';

export default FamilyPromoCard;
